// extracted by mini-css-extract-plugin
export var formContainer = "_ff-0";
export var message = "_ff-1";